import { useEffect, useState, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import React from "react";
import { NavDropdown } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import MobileMenu from "./MobileMenu";

export default function Header({ simple }) {
  const [isSticky, setIsSticky] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const handleToggleMenu = useCallback(() => setIsOpen((prev) => !prev), []);

  const [activeKey, setActiveKey] = useState("plat-tab1");
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    const heightFromTop = window.scrollY;
    setIsSticky(heightFromTop > 0);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setDropdownOpen2(false); // close dropdown on navigation
  }, [location.pathname]);

  useEffect(() => {
    const slug = location.pathname.replace(/^\/|\/$/g, "");

    if (tabMap[slug]) {
      setActiveKey(tabMap[slug]);
    } else {
      setActiveKey("plat-tab1"); // default
    }
  }, [location.pathname]);

  const tabMap = {
    "haldi-dresses": "plat-tab1",
    "mehandi-dresses": "plat-tab2",
    "sangeet-suit": "plat-tab3",
    contemporary: "plat-tab4",
    "wedding-dress-designers": "plat-tab5",
    festive: "plat-tab6",
  };

  if (simple) {
    return (
      <header className="toolbar-header">
        <Link to={"/"}>
          <img src="/image/logo.webp" alt="Logo" />
        </Link>
      </header>
    );
  }

  return (
    <>
      <header className="header-main">
        <div className="book-strip">
          Book An in-Store or Video Appointment for Personalized Services!
        </div>

        <div className={`header-area ${isSticky ? "stick" : ""}`}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 col-md-5 mobile-menu">
                <ul className="main-menu">
                  <li>
                    <Link to={"/about-us"}>About</Link>
                  </li>

                  <li className="has-dropdown">
                    <NavDropdown
                      id="nav-dropdown-dark-example"
                      title="Collection"
                      menuVariant="light"
                      show={dropdownOpen2}
                      onToggle={(isOpen) => setDropdownOpen2(isOpen)}
                    >
                      <div className="bigmenu-data">
                        <Tab.Container
                          activeKey={activeKey}
                          onSelect={setActiveKey}
                        >
                          <Nav className="bigmenu-tablink">
                            <p>Collection</p>
                            <Nav.Item>
                              <Nav.Link
                                to={"/haldi-dresses"}
                                as={Link}
                                eventKey="plat-tab1"
                                onMouseEnter={() => setActiveKey("plat-tab1")}
                              >
                                Haldi
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link
                                to={"/mehandi-dresses"}
                                as={Link}
                                eventKey="plat-tab2"
                                onMouseEnter={() => setActiveKey("plat-tab2")}
                              >
                                Mehandi
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link
                                to={"/sangeet-suit"}
                                as={Link}
                                eventKey="plat-tab3"
                                onMouseEnter={() => setActiveKey("plat-tab3")}
                              >
                                Sangeet
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link
                                to={"/contemporary"}
                                as={Link}
                                eventKey="plat-tab4"
                                onMouseEnter={() => setActiveKey("plat-tab4")}
                              >
                                Contemporary
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link
                                to={"/wedding-dress-designers"}
                                as={Link}
                                eventKey="plat-tab5"
                                onMouseEnter={() => setActiveKey("plat-tab5")}
                              >
                                Wedding
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link
                                to={"/festive-wear"}
                                as={Link}
                                eventKey="plat-tab6"
                                onMouseEnter={() => setActiveKey("plat-tab6")}
                              >
                                festive
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>

                          <Tab.Content className="bigmenu-tabcontent">
                            <Tab.Pane eventKey="plat-tab1">
                              <img
                                src="/image/tabmenu-img1.webp"
                                className="img-responsive"
                                alt="Collection"
                              />
                            </Tab.Pane>
                            <Tab.Pane eventKey="plat-tab2">
                              <img
                                src="/image/tabmenu-img2.webp"
                                className="img-responsive"
                                alt="Collection"
                              />
                            </Tab.Pane>
                            <Tab.Pane eventKey="plat-tab3">
                              <img
                                src="/image/tabmenu-img3.webp"
                                className="img-responsive"
                                alt="Collection"
                              />
                            </Tab.Pane>
                            <Tab.Pane eventKey="plat-tab4">
                              <img
                                src="/image/tabmenu-img4.webp"
                                className="img-responsive"
                                alt="Collection"
                              />
                            </Tab.Pane>
                            <Tab.Pane eventKey="plat-tab5">
                              <img
                                src="/image/tabmenu-img5.webp"
                                className="img-responsive"
                                alt="Collection"
                              />
                            </Tab.Pane>
                            <Tab.Pane eventKey="plat-tab6">
                              <img
                                src="/image/tabmenu-img6.webp"
                                className="img-responsive"
                                alt="Collection"
                              />
                            </Tab.Pane>
                          </Tab.Content>
                        </Tab.Container>
                      </div>
                    </NavDropdown>
                  </li>

                  <li>
                    <Link to={"/our-process"}>Our Process</Link>
                  </li>
                  <li>
                    <Link to={"/gifting"}>Gifting</Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-md-2 col-sm-6 col-6">
                <div className="logo">
                  <Link to={"/"}>
                    <img src="/image/logo.webp" alt="Logo" />
                  </Link>
                </div>
              </div>

              <div className="col-lg-5 col-md-5 col-sm-6 col-6">
                <ul className="main-menu right-mainmenu">
                  <li>
                    <Link to={"/wedding-dress-designers"}>
                      <small>New</small>Wedding Closet
                    </Link>
                  </li>
                  <li>
                    <Link to={"/collaboration"}>Collaboration</Link>
                  </li>
                  <li>
                    <Link to={"/contact"}>Appointment</Link>
                  </li>
                </ul>

                <div className="menu-toogle" onClick={handleToggleMenu}>
                  <div className="menu-line icon-top"></div>
                  <div className="menu-line icon-center"></div>
                  <div className="menu-line icon-bottom"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
}
